/* T FOR ALL — Size Finder. Height + weight -> recommended size; selects the
   matching size/length pills on the product form. If the exact recommended
   size/length isn't offered, it falls back to the closest available option
   and tells the shopper what changed. */
(function () {
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];

  function sizeFromWeight(kg) {
    if (kg < 58) return 'XS';
    if (kg < 65) return 'S';
    if (kg < 72) return 'M';
    if (kg < 80) return 'L';
    if (kg < 90) return 'XL';
    if (kg < 102) return 'XXL';
    return 'XXXL';
  }
  function lengthFromHeight(cm) { return cm >= 178 ? '38' : '36'; }

  // Normalize a pill label to a canonical size token (e.g. "2XL" -> "XXL",
  // "M (10-12)" -> "M"). Returns '' if it isn't a size.
  function normSize(text) {
    var t = (text || '').toUpperCase().split('(')[0].replace(/[\s.]/g, '');
    var alias = { '2XL': 'XXL', '3XL': 'XXXL', '4XL': 'XXXXL' };
    if (alias[t]) t = alias[t];
    return SIZE_ORDER.indexOf(t) !== -1 ? t : '';
  }
  // Extract a numeric length token (e.g. '36"' -> '36'). Returns '' if none.
  function normLen(text) {
    var m = (text || '').match(/(\d{2})\s*["”]?/);
    return m ? m[1] : '';
  }

  function inputFor(lbl) {
    if (lbl.htmlFor) { var byId = document.getElementById(lbl.htmlFor); if (byId) return byId; }
    return lbl.querySelector('input');
  }
  function isAvailable(lbl) {
    var input = inputFor(lbl);
    if (input && input.disabled) return false;
    return !/disabled|unavailable|sold-?out/i.test(lbl.className);
  }

  // Read the size + length pills currently on the page.
  function gather(scope) {
    var sizes = [], lens = [];
    (scope || document).querySelectorAll('.product-form__input--pill label').forEach(function (lbl) {
      var raw = (lbl.textContent || '').trim();
      var avail = isAvailable(lbl);
      var s = normSize(raw);
      if (s) { sizes.push({ label: lbl, token: s, avail: avail }); return; }
      var l = normLen(raw);
      if (l) lens.push({ label: lbl, token: l, avail: avail });
    });
    return { sizes: sizes, lens: lens };
  }

  // Pick the closest option to `token`. `distance(tokenA)` returns a number.
  // Prefers exact + available, then closest available, then closest existing.
  // On a tie, `preferUp` chooses the larger option.
  function pickClosest(arr, token, distance, preferUp) {
    if (!arr.length) return null;
    var exact = arr.filter(function (o) { return o.token === token && o.avail; });
    if (exact.length) return { choice: exact[0], exact: true };

    var pool = arr.filter(function (o) { return o.avail && distance(o.token) != null; });
    if (!pool.length) pool = arr.filter(function (o) { return distance(o.token) != null; });
    if (!pool.length) return null;

    pool.sort(function (a, b) {
      var da = distance(a.token), db = distance(b.token);
      if (da !== db) return da - db;
      var ai = SIZE_ORDER.indexOf(a.token), bi = SIZE_ORDER.indexOf(b.token);
      if (ai !== -1 && bi !== -1) return preferUp ? bi - ai : ai - bi;
      return preferUp ? (+b.token) - (+a.token) : (+a.token) - (+b.token);
    });
    return { choice: pool[0], exact: false };
  }

  function selectPills(state) {
    if (state.size && state.size.choice) state.size.choice.label.click();
    if (state.len && state.len.choice) state.len.choice.label.click();
  }

  function setup(sf) {
    if (sf.dataset.sfInit) return; sf.dataset.sfInit = '1';
    // Localized message templates (passed from Liquid via data-* attrs; English fallbacks).
    function i18n(key, fallback) {
      return sf.getAttribute('data-i18n-' + key) || fallback;
    }
    function fmt(tpl, vars) {
      return tpl.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    }
    var overlay = sf.querySelector('[data-sf-overlay]');
    var steps = {};
    sf.querySelectorAll('[data-sf-step]').forEach(function (s) { steps[s.getAttribute('data-sf-step')] = s; });
    function show(n) { Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== String(n)); }); }
    function open() {
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      overlay.hidden = false; document.body.style.overflow = 'hidden'; show(1);
    }
    function close() { overlay.hidden = true; document.body.style.overflow = ''; }

    sf.querySelector('[data-sf-open]').addEventListener('click', open);
    sf.querySelectorAll('[data-sf-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    var h = sf.querySelector('[data-sf-height]'), hOut = sf.querySelector('[data-sf-height-out]');
    var w = sf.querySelector('[data-sf-weight]'), wOut = sf.querySelector('[data-sf-weight-out]');
    h.addEventListener('input', function () { hOut.textContent = h.value; });
    w.addEventListener('input', function () { wOut.textContent = w.value; });

    sf.querySelectorAll('[data-sf-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.getAttribute('data-sf-next')); });
    });

    var resultEl = sf.querySelector('[data-sf-result]');
    var adjustEl = sf.querySelector('[data-sf-adjust]');
    var pick = { size: null, len: null };

    sf.querySelector('[data-sf-recommend]').addEventListener('click', function () {
      var recSize = sizeFromWeight(+w.value);
      var recLen = lengthFromHeight(+h.value);
      var data = gather();

      var recIdx = SIZE_ORDER.indexOf(recSize);
      pick.size = pickClosest(data.sizes, recSize, function (tok) {
        var i = SIZE_ORDER.indexOf(tok); return i === -1 ? null : Math.abs(i - recIdx);
      }, true);
      pick.len = data.lens.length ? pickClosest(data.lens, recLen, function (tok) {
        return Math.abs(+tok - +recLen);
      }, false) : null;

      var gotSize = pick.size ? pick.size.choice.token : recSize;
      var gotLen = pick.len ? pick.len.choice.token : (data.lens.length ? recLen : '');
      resultEl.textContent = gotSize + (gotLen ? '  ·  ' + gotLen + '"' : '');

      var msgs = [];
      if (!pick.size) {
        msgs.push(i18n('no-size', 'This style isn’t available in your size.'));
      } else if (!pick.size.exact) {
        msgs.push(fmt(i18n('size-fallback', 'We don’t have {recSize} in this style. {token} is the closest fit.'), { recSize: recSize, token: pick.size.choice.token }));
      }
      if (pick.len && !pick.len.exact) {
        msgs.push(fmt(i18n('len-fallback', 'Length {recLen}" isn’t available. Using {token}".'), { recLen: recLen, token: pick.len.choice.token }));
      }
      if (msgs.length) { adjustEl.textContent = msgs.join(' '); adjustEl.hidden = false; }
      else { adjustEl.textContent = ''; adjustEl.hidden = true; }

      show('result');
    });

    sf.querySelector('[data-sf-apply]').addEventListener('click', function () {
      selectPills(pick);
      close();
    });
  }

  function init(root) { (root || document).querySelectorAll('[data-size-finder]').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
